// Add event listener to handle clicks on product cards
document.addEventListener("click", function (e) {
  if (
    !e.target.matches("[data-prevent-click]") &&
    (e.target.matches(".product-card a") || e.target.closest(".product-card a"))
  ) {
    // If the clicked element is within a product card, navigate to its href
    const productCardLink = e.target.closest(".product-card a");
    if (productCardLink) {
      window.location.href = productCardLink.getAttribute("href");
    }
  }
});

// Add event listener to handle clicks on quick add buttons
document.querySelectorAll(".product-card").forEach(function (productCard) {
  const quickAddButton = productCard.querySelector(".product-card__quick-add-button");
  if (quickAddButton) {
    quickAddButton.addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelector(".product-card[open]")?.removeAttribute("open");
      productCard.setAttribute("open", "");
    });
  } 
});


// Close open product card when clicking anywhere on the page
document.addEventListener("click", function (e) {
  if (!e.target.closest(".product-card") && document.querySelector(".product-card[open]")) {
    document.querySelector(".product-card[open]").removeAttribute("open");
  }
});
